// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';

export const RESOURCES_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  avatarBackground: SEMANTIC_COLORS.background.tertiary,
  innerFrameBackground: SEMANTIC_COLORS.background.primary,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray400,
  textMuted: PRIMITIVE_COLORS.white50,
  linkBlue: PRIMITIVE_COLORS.resioBlueLight,
  linkPink: PRIMITIVE_COLORS.resioPink,
  purpleBadge: PRIMITIVE_COLORS.resioPurpleLight,
  purpleBadgeBg: PRIMITIVE_COLORS.purpleBg50,
  accentBlueBorder: PRIMITIVE_COLORS.resioBlueBorder,
  iconPrimary: SEMANTIC_COLORS.icon.primary,
  iconSecondary: SEMANTIC_COLORS.icon.secondary,
} as const;

export const WIFI_GRADIENT = {
  colors: ['#EF303D', '#B53369', '#7B3794', '#5E39AA', '#413AC0', '#243CD6', '#153DE1', '#073EEC'],
  locations: [0, 0.25, 0.5, 0.625, 0.75, 0.875, 0.9375, 1],
} as const;

export type ResourcesColor = keyof typeof RESOURCES_COLORS;
